module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M7.02 24h-6c-.552 0-.684.316-.292.708l6.576 6.586c.39.39.696.258.696-.294v-6c0-.552-.428-1-.98-1zm19-24h-24C.914 0 0 .894 0 2v19c0 .552.466 1 1.02 1h8c.552 0 .98.448.98 1v8c0 .552.466 1 1.02 1h15c1.106 0 1.98-.894 1.98-2V2c0-1.106-.876-2-1.98-2zM22 15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2zm0-6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/document-2.js
// module id = 1101
// module chunks = 14